// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"aa5b8858","551":"44bcbe76","980":"0e3ac307"}[chunkId] + ".chunk.js";
};